cb.define(['common/common_VM.Extend.js'], function (common) {


    var PM_pmc_packagesaleslist_filterVM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var userViewModel = cb.rest.AppContext.user;
            viewmodel.on("afterInit", function () {
                common.displayProductFiltering(viewmodel, userViewModel);
            });
        }
    };
    try {
        module.exports = PM_pmc_packagesaleslist_filterVM_Extend;
    } catch (error) {

    }
    return PM_pmc_packagesaleslist_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_packagesaleslist_filterVM.Extend.js